"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateQuery = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useCreateQuery() {
    const { data, isLoading, error, post } = (0, core_ui_1.useApiPost)('queries');
    return {
        createdQuery: data,
        isCreating: isLoading,
        error,
        createQuery: post
    };
}
exports.useCreateQuery = useCreateQuery;
//# sourceMappingURL=useCreateQuery.js.map